import React from 'react';
import { useTranslate } from '../../../components/TranslationText';
import {
    aedLogoStyle,
    getDirhamImage,
    iconContainer,
    showIconsContainer,
} from '../../../common/cssclasses';

/**
 * Stallion info bar showing birth date, color, origin, and price.
 *
 * @param {object} semenDetails - Stallion details from API
 */
export default function SemenStallionInfoBar({ semenDetails, orderDetails, isAdditionalDose }) {
    const { translate } = useTranslate();
    const currentlang = localStorage.getItem('eahsLang') ?? 'en';

    if (!semenDetails) return null;

    function detailsRow(icon, key, value, classNames = '') {
        return (
            <div className={iconContainer + ' ' + classNames}>
                <i className={`${icon} C89C66`} />
                <span className="fw-bold">
                    {translate(key, key) + ': '} {value || translate('web.unknown', 'unknown')}
                </span>
            </div>
        );
    }

    return (
        <div className={showIconsContainer}>
            {detailsRow('fa fa-calendar', 'web.birthDate', semenDetails.birthDate, 'w-unset')}
            {detailsRow('fa fa-palette', 'web.color', semenDetails.color, 'w-unset')}
            {detailsRow('fa fa-earth-americas', 'web.origin', semenDetails.origin, 'w-unset')}
            <div className={iconContainer}>
                <img src={getDirhamImage(currentlang)} alt="AED" style={aedLogoStyle} />
                <span className="fw-bold">
                    {translate('web.price', 'Price') + ': '}{' '}
                    {isAdditionalDose 
                        ? (orderDetails?.extraDosePrice?.toLocaleString('en-US')) 
                        : (orderDetails?.orderPrice ?? semenDetails.price?.toLocaleString('en-US'))}{' '}
                    {translate('web.aed', 'AED')}
                </span>
            </div>
        </div>
    );
}
